import { render, staticRenderFns } from "./ArticleEdition.vue?vue&type=template&id=33ec8917&"
import script from "./ArticleEdition.vue?vue&type=script&lang=js&"
export * from "./ArticleEdition.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEdition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports